import moment from 'moment-timezone';
import { getNextDay, getPreviousDay, ValidTimeFormats } from '../DateUtilities';
// Back end throws exception of year zero is sent down.
export var notYearZero = function (dateFormat) { return function (value) {
    if (!value)
        return true;
    var selectedDate = moment(value, dateFormat);
    return selectedDate.year() !== 0;
}; };
export function validMoment(value) {
    if (!!value) {
        return value.isValid();
    }
    return true;
}
export var dateBeforeToday = function (format) { return function (date) {
    return moment(date, format).isSameOrBefore(moment(), 'day');
}; };
export var timeBeforeToday = function (format) { return function (time) {
    return moment(time, format).isSameOrBefore(moment(), 'minute');
}; };
export function validate24HrTime(time) {
    if (!!time) {
        time = time.substring(0, 5);
        return moment(time, ValidTimeFormats.Format24HR, true).isValid();
    }
    return true;
}
export var availabilityTest = function (availabilities) {
    var errors = [];
    if (availabilities.length === 0)
        return true;
    availabilities.forEach(function (targetAvailability, index) {
        var previousDay = getPreviousDay(targetAvailability.dayOfWeek);
        var nextDay = getNextDay(targetAvailability.dayOfWeek);
        var previousAvailability = availabilities.find(function (it) { return it.dayOfWeek === previousDay; });
        var nextAvailability = availabilities.find(function (it) { return it.dayOfWeek === nextDay; });
        if (targetAvailability) {
            var targetAvailabilityEndMoment = moment(targetAvailability.endTime, ValidTimeFormats.Format24HR);
            var targetAvailabilityStartMoment = moment(targetAvailability.startTime, ValidTimeFormats.Format24HR);
            if (previousAvailability) {
                var previousAvailabilityStartMoment = moment(previousAvailability.startTime, ValidTimeFormats.Format24HR);
                var previousAvailabilityEndMoment = moment(previousAvailability.endTime, ValidTimeFormats.Format24HR);
                if (previousAvailabilityEndMoment.isBefore(previousAvailabilityStartMoment)) {
                    if (previousAvailabilityEndMoment.isAfter(targetAvailabilityStartMoment)) {
                        errors.push({
                            name: '',
                            message: 'Time conflict',
                            value: '',
                            path: "availability[" + index + "].startTime",
                            type: '',
                            errors: [],
                            inner: []
                        });
                    }
                }
            }
            if (nextAvailability) {
                var nextAvailabilityStartMoment = moment(nextAvailability.startTime, ValidTimeFormats.Format24HR);
                if (targetAvailabilityEndMoment.isBefore(targetAvailabilityStartMoment)) {
                    if (targetAvailabilityEndMoment.isAfter(nextAvailabilityStartMoment)) {
                        errors.push({
                            name: '',
                            message: 'Time conflict',
                            value: '',
                            path: "availability[" + index + "].endTime",
                            type: '',
                            errors: [],
                            inner: []
                        });
                    }
                }
            }
        }
    });
    if (errors.length)
        throw {
            path: 'availability',
            message: 'Timeslots overlap',
            inner: errors
        };
    return true;
};
